import { Search } from 'lucide-react';
import type { KeyboardEvent } from 'react';

import { NAV_THEMES, type NavTheme } from './nav-tokens';

interface PaletteInputProps {
  value: string;
  onChange: (v: string) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  /** The result list this input drives, and the row currently highlighted in it. */
  listId: string;
  activeOptionId: string | null;
  theme: NavTheme;
}

/** The palette's query field, with the esc hint. */
export default function PaletteInput({
  value,
  onChange,
  onKeyDown,
  inputRef,
  listId,
  activeOptionId,
  theme,
}: PaletteInputProps) {
  const t = NAV_THEMES[theme];
  return (
    <div
      className="flex items-center"
      style={{
        gap: 10,
        padding: '14px 16px',
        borderBottom: `1px solid ${t.border}`,
        color: t.subtle,
      }}
    >
      <Search size={16} aria-hidden />
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        role="combobox"
        aria-label="Search"
        aria-expanded="true"
        aria-autocomplete="list"
        aria-controls={listId}
        aria-activedescendant={activeOptionId ?? undefined}
        placeholder="Search venues, bookings, private events…"
        className="w-full"
        style={{
          border: 0,
          outline: 'none',
          background: 'transparent',
          fontSize: 14,
          color: t.ink,
        }}
      />
      <kbd
        style={{
          fontFamily: 'var(--font-mono, ui-monospace)',
          fontSize: 10,
          padding: '2px 5px',
          borderRadius: 4,
          background: t.surface,
          color: t.subtle,
        }}
      >
        esc
      </kbd>
    </div>
  );
}
